<template>
  <v-layout column class="text-right w-fit ml-auto">
    <router-link :to="link" class="none-underline">
      <slot></slot>
    </router-link>
  </v-layout>
</template>

<script>
export default {
  name: 'LinkLabel',
  props: {
    link: {
      type: String,
      required: false,
      default: ''
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/_atoms/labels/LinkLabel.vue